<template>
	<div class="alert" @click.stop="close">
		<div class="alert-box">
			<div class="title">

				<img class="sign decorate" src="../../assets/img/home/decorate-left.png" />
				&nbsp;&nbsp;{{itemData.name}}&nbsp;&nbsp;
				<img class="sign decorate" src="../../assets/img/home/decorate-right.png" />
			</div>
			<div class="body">
				<div class="info">

					<img :src="itemData.url" />


				</div>
				<div v-html="itemData.mark">
					<br />1. 每名用户每日成功签到一次，可获得1次抽奖机会；
					<br />2. 首次输入手机号验证登陆后，可获得5次抽奖机会；
					<br />3. 分享成功后每日可额外获得1次抽奖机会；
					<br />4. xx月xx日xx：xx点开启预下载，预下载当天，成功签到后，可额外获得5次抽奖机会；
					<br />5. xx月xx日公测当天，成功签到后，可额外获得5次抽奖机会；
					<br />6. xx月xx日零点之前完成手游安装，可额外获得20次抽奖机会
					<br />7. 关注官方微博，可额外获得5次抽奖机会；立即前往
					<br />8. 关注官方公众号，可额外获得5次抽奖机会；立即前往
					<br />9. 奖品分为游戏礼包奖励与实物奖励；
					<br />10. 游戏公测后，使用同一手机号在本APP内下载登陆游戏服务器，可在七个工作日内自动获取游戏礼包
					<br />11.
					实物奖励中奖后，用户可在个人中心中查看奖励并填写个人信息，游戏公测时使用同一手机号在本APP内下载登陆游戏服务器后安排发货。用户未在限定时间内填写个人收货信息，则视为主动放弃实物奖励；
					<br />12. 本次活动解释权归《我的门派》手游官方所有。
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "alert",
		props: ['itemData'],
		data() {
			return {};
		},
		created() {

		},
		computed: {

		},
		methods: {
			close() {
				this.$emit('close')
			}
		},
	};
</script>
<style scoped>
	.alert {
		height: 100vh;
		width: 100vw;
		position: absolute;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.2);
		display: table-cell;
		text-align: center;
		vertical-align: middle;
	}

	.alert-box {
		border-radius: 6px;
		width: 80%;
		left: 10%;
		margin: 0 auto;
		position: fixed;
		top: 60px;
		overflow: hidden;
	}

	.title {
		background-color: #F6E9B2;
		color: #686e3f;
		padding: 6px;
	}

	.body {
		background-color: #E4C677;
		padding: 10px;
		max-height: 400px;
		overflow-y: scroll;
		text-align: left;
		color: #BD8E5B;
		padding: 10px;
	}

	.info {
		border-radius: 6px;
		background-color: #F6E9B2;
	}

	.info img {
		display: block;
		width: 70%;
		margin: 0 auto;
	}

	.decorate {
		width: 20%;
	}
</style>
